/** What a user may manage, sent by the backend as `user.abilities` (backend ADR 0007). */
export const ABILITIES = {
	manageBilling: "manage-billing",
	manageAccount: "manage-account",
	manageTeam: "manage-team",
	manageSourceQrCodes: "manage-source-qr-codes",
};

export const can = (user, ability) => Boolean(user?.abilities?.includes(ability));
